import { http } from '@/core/api'
import type { AnalyticsOperationsResponse, OperationsDetailsResponse, OperationsReconciliationResponse } from '../types/analytics-operations.types'

export const analyticsOperationsApi = {
  async overview(params: Record<string, unknown>, signal?: AbortSignal) {
    const response = await http.get<{ data: AnalyticsOperationsResponse }>('/analytics/v1/operations', { params, signal })
    return response.data.data
  },
  async details(params: { snapshot_id: string; metric_code: string; bucket_key?: string; page?: number; per_page?: number }, signal?: AbortSignal) {
    const response = await http.get<{ data: OperationsDetailsResponse }>('/analytics/v1/operations/details', { params, signal })
    return response.data.data
  },
  async reconcile(params: { snapshot_id: string; left: string; right: string }) {
    const response = await http.get<{ data: OperationsReconciliationResponse }>('/analytics/v1/operations/reconcile', { params })
    return response.data.data
  },
}
